import API from "../../api/api";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const EpinService = {
    callEpinTiles: async () => {
        return callApi('epin-tiles');
    },
    callEpinList: async (page, perPage, epin, amount, status, sortBy, direction) => {
        return callApi(`epin-list?page=${page}&perPage=${perPage}&epins=${epin}&amounts=${amount}&status=${status}&sortBy=${sortBy}&direction=${direction}`);
    },
    callEpinPendingRequest: async (page, perPage, sortBy, direction) => {
        return callApi(`pending-epin-request?page=${page}&perPage=${perPage}&sortBy=${sortBy}&direction=${direction}`);
    },
    callEpinTransferHistory: async (page, perPage, sortBy, direction) => {
        return callApi(`epin-transfer-history?page=${page}&perPage=${perPage}&sortBy=${sortBy}&direction=${direction}`);
    },
    callEpinPurchase: async (data) => {
        return API.post("epin-purchase", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));

    },
    callEpinRequest: async (data) => {
        // Use multipart/form-data for file upload
        console.log("🌐 API: Sending epin-request with FormData");
        console.log("Request URL:", "epin-request?type=epin_receipts");
        console.log("Data is FormData:", data instanceof FormData);
        
        // Log FormData contents
        if (data instanceof FormData) {
            console.log("📦 API: FormData contents:");
            for (let [key, value] of data.entries()) {
                if (value instanceof File) {
                    console.log(`  ${key}:`, {
                        name: value.name,
                        type: value.type,
                        size: value.size
                    });
                } else {
                    console.log(`  ${key}:`, value);
                }
            }
        }
        
        // Don't set Content-Type header - let browser set it with boundary for FormData
        return API.post("epin-request?type=epin_receipts", data)
            .then((response) => {
                console.log("✅ API: Request successful", response);
                return response;
            })
            .catch((error) => {
                console.error("❌ API: Request failed", error);
                console.error("Error response:", error?.response);
                console.error("Error status:", error?.response?.status);
                console.error("Error data:", error?.response?.data);
                return Promise.reject(error);
            });
    },
    callEpinTransfer: async (data) => {
        return API.post("epin-transfer", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callEpinRefund: async (data) => {
        return API.post("epin-refund", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callPurchasedEpinList: async () => {
        return callApi(`purchased-epin-list`);
    },
    callEpinPartials: async () => {
        return callApi('epin-partials');
    }
}